// Entity types are the different types of components/questions that comprise a flow
export enum EntityTypes {
  REPORT_COMPONENT = 'report-component',
  INTERACTIVE_COMPONENT = 'interactive-v2-component',
  STATIC_COMPONENT = 'static-component',
  QUESTION = 'question',
  QUESTION_MINIFIED = 'question-minified',
  QUESTION_MAPPED = 'question-mapped', // this is not an actual type by data, but is calculated based on conditions and used like it is
}
